import * as Icons from "react-icons/hi";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
interface InputProps {
  label: string;
  name: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasLabel?: boolean;
  placeHolder?: string;
  icon?: {
    iconName: string;
    color?: string;
    size?: number;
  };
  onChange: (value: any) => void;
  data?: any;
}

const TextAreaInput = (props: InputProps) => {
  const handleChange = (e: any) => {
    props.onChange(e);
  };
  const n = props.icon?.iconName ?? "";
  const IconComponent = (Icons as any)[n];
  return (
    <div className="flex flex-col space-y-2 w-[100%] relative mb-10">
      {props.hasLabel && (
        <label>
          {props.label}{" "}
          <span className="text-red-600">{props.required ? "*" : ""}</span>
        </label>
      )}
      <ReactQuill
        className={props.className}
        theme="snow"
        value={props.data}
        defaultValue={props.data}
        onChange={handleChange}
      />
      {/* {props.hasLabel && (
        <label>
          {props.label}{' '}
          <span className="text-red-600">{props.required ? '*' : ''}</span>
        </label>
      )}
      <span className="absolute bottom-3 left-4">
        {props.icon === undefined || props.icon === null ? null : (
          <IconComponent size={props.icon.size} color={props.icon.color} />
        )}
      </span>
      <textarea
        value={props.data || ''}
        onChange={handleChange}
        placeholder={props.placeHolder}
        name={props.name}
        className={`h-24 md:h-20 border-[1px] px-4 py-2 rounded-md border-[#E4E4E7] ${
          props.icon === undefined || props.icon === null ? 'pl-3' : 'pl-16'
        } ${props.className}`}
        disabled={props.disabled}
        required={props.required}
      /> */}
    </div>
  );
};

export default TextAreaInput;
